import { getCurrentUserInfoApiV1AuthMeGet } from '@/common/api/client/sdk.gen'
import type { UserResponse } from '@/common/api/client/types.gen'
import { useQuery } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

export type { UserResponse }

export type TAuth = boolean

const fetchMe = async (): Promise<UserResponse> => getCurrentUserInfoApiV1AuthMeGet().then(res => res.data!)

export const useMe = (flag: TAuth = true) => {
    const {
        data: me,
        isLoading,
        isError,
        refetch,
        isSuccess,
        error,
    } = useQuery<UserResponse, AxiosError>({
        queryKey: ['me'],
        queryFn: fetchMe,
        retry: false,
        enabled: flag,
        refetchOnWindowFocus: false,
        staleTime: 5 * 60 * 1000,
    })

    return {
        me,
        isLoading,
        isSuccess,
        isError,
        refetch,
        error,
    }
}
